export default function initContactFormTabs() {
    // ==========================================================
    // CONTACT FORM
    // ==========================================================

    const sections = document.querySelectorAll("[data-contact-form-tabs]");

    if (!sections.length) {
        return;
    }

    sections.forEach((section) => {
        const tabs = section.querySelectorAll("[data-contact-form-tab]");

        const panels = section.querySelectorAll("[data-contact-form-panel]");

        if (!tabs.length || !panels.length) {
            return;
        }

        // ======================================================
        // ACTIVER UN ONGLET
        // ======================================================

        const activateTab = (tab) => {
            const target = tab.dataset.contactFormTab;

            if (target === undefined) {
                return;
            }

            // --------------------------------------------------
            // ONGLETS
            // --------------------------------------------------

            tabs.forEach((item) => {
                const isActive = item === tab;

                item.classList.toggle("is-active", isActive);

                item.setAttribute("aria-selected", isActive ? "true" : "false");

                item.setAttribute("tabindex", isActive ? "0" : "-1");
            });

            // --------------------------------------------------
            // PANELS
            // --------------------------------------------------

            panels.forEach((panel) => {
                const isActive = panel.dataset.contactFormPanel === target;

                panel.classList.toggle("hidden", !isActive);

                panel.hidden = !isActive;
            });
        };

        // ======================================================
        // CLIC
        // ======================================================

        tabs.forEach((tab) => {
            tab.addEventListener("click", () => {
                activateTab(tab);
            });
        });

        // ======================================================
        // NAVIGATION CLAVIER
        // ======================================================

        tabs.forEach((tab, index) => {
            tab.addEventListener("keydown", (event) => {
                let nextIndex = null;

                if (event.key === "ArrowRight") {
                    nextIndex = (index + 1) % tabs.length;
                }

                if (event.key === "ArrowLeft") {
                    nextIndex = (index - 1 + tabs.length) % tabs.length;
                }

                if (event.key === "Home") {
                    nextIndex = 0;
                }

                if (event.key === "End") {
                    nextIndex = tabs.length - 1;
                }

                if (nextIndex === null) {
                    return;
                }

                event.preventDefault();

                const nextTab = tabs[nextIndex];

                activateTab(nextTab);

                nextTab.focus();
            });
        });

        // ======================================================
        // INITIALISATION
        // ======================================================

        const activeTab = section.querySelector('[data-contact-form-tab][aria-selected="true"]') || tabs[0];

        if (activeTab) {
            activateTab(activeTab);
        }
    });
}
